import hiwOpenTemplateHtml from 'directives/hiw-open.template.html';

import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

import { dialogController } from 'common/dialogs/dialog.controller';



@Injectable('DialogService')
export class DialogService {

  private mdDialogOpts: any = {
    dialogClass: null,
    escapeToClose: true,
    controllerAs: '$ctrl',
    bindToController: true,
    clickOutsideToClose: true,
    controller: dialogController,
  };

  constructor(
    @Inject('$mdDialog') private $mdDialog,
  ) {}

  openDialog(overrides: any, $event?: Event) {
    const options = Object.assign({}, this.mdDialogOpts, overrides);

    options.targetEvent = $event;

    options.template = `
      <md-dialog class="${options.dialogClass}">
        <md-dialog-content class="gw-dialog">
          ${options.template}

          <button
            class="gw-dialog__close"
            ng-click="$ctrl.cancelThisDialog()"
          ></button>
        </md-dialog-content>
      </md-dialog>
    `;

    return this.$mdDialog
      .show(options)
      .catch(e => e);
  }

  openAlert(content) {
    const template = `
      <div class="gw-alert" layout="column" layout-align="center center">
        <img src="${content.icon || '/img/errors/error.svg'}" alt="" />

        <h2 class="md-title">
          ${content.title || 'Oops'}
        </h2>
        <div class="md-dialog-content-body">
          <p>${content.text || 'There was an error'}</p>
        </div>
      </div><!--/ .gw-alert -->
    `;

    return this.openDialog({
      template,
    });
  }

  openUserAuth(overrides: any, $event?: Event): ng.IHttpPromise<any> {
    const options = Object.assign({}, this.mdDialogOpts, overrides);

    options.template = `
      <gw-authentication
        (on-cancel)="$ctrl.cancelThisDialog($event)"
        (on-finish)="$ctrl.closeThisDialog($event)"
      ></gw-authentication>
    `;

    return this.openDialog(options, $event);
  }

  openHowItWorks($event?: Event): ng.IHttpPromise<any> {
    const overrides = {
      dialogClass: 'gw-hiw-dialog',
    };

    const options = Object.assign({}, this.mdDialogOpts, overrides);

    const passportsBrand = (window as any).gwPassportsBrand;
    options.template = passportsBrand && passportsBrand.phone
      ? hiwOpenTemplateHtml.replace('(800) 224-4154', passportsBrand.phone)
      : hiwOpenTemplateHtml;

    return this.openDialog(options, $event);
  }

  openHappyGuarantee(overrides: any, $event?: Event): ng.IHttpPromise<any> {
    const options = Object.assign({}, this.mdDialogOpts, overrides);

    options.contentElement = '#js-dialog-happy-guarantee';

    return this.openDialog(options, $event);
  }

  /**
   * User account password confirmation dialog.
   */
  openAuthConfirm(overrides: any, $event?: Event): ng.IHttpPromise<any> {
    const options = Object.assign({}, this.mdDialogOpts, overrides);

    options.template = `
      <gw-user-auth-confirm
        (on-finish)="$ctrl.closeThisDialog(true)"
      ></gw-user-auth-confirm>
    `;

    return this.openDialog(options, $event);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/dialog.service.ts